import loadable from '@loadable/component';

export const AmazonPrimeShipping = loadable(
  () => import(/* webpackChunkName: 'amazon-prime-shipping' */ './AmazonPrimeShipping'),
);
